module.exports = __webpack_public_path__ + "img/ball-dark.f92f81f9.svg";